import React, { useState } from 'react';
import './aboutUs.css';

const AboutUs = () => {
  const [selectedTab, setSelectedTab] = useState('Visi');

  const content = {
    Visi: [
      "To become a leading company in the various industry by providing innovative solutions, exceptional customer service, and fostering strong partnerships with our clients and suppliers."
    ],
    Misi: [
      "Our mission is to deliver high-quality products and services to our customers while maintaining the highest standards of integrity, professionalism, and ethical business practices.",
      "We strive to continuously improve and adapt to the ever-changing market dynamics in order to exceed the expectations of our stakeholders and contribute to the growth and success of our business."
    ],
  };

  return (
    <div className="about-us-container">
      <div className="image-container">
        <img src="MarsAcmePerkasa.png" alt="About Us" className="about-us-image" />
      </div>
      <div className="tab-title-box">
        {Object.keys(content).map((tab) => (
          <button
            key={tab}
            className={`tab-title ${selectedTab === tab ? "active" : ""}`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </button>
        ))}   
      </div>
      <div className="info-box">
        <div className="tab-content">
          <ul>
            {content[selectedTab].map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
